export const ajmWorks = {
  movie: [
    {
      id: 1,
      title: '우키시마호',
      year: '2019',
      image: require('./movie/1. 우키시마호.webp')
    },
    {
      id: 2,
      title: '카리스마 탈출기',
      year: '2006',
      image: require('./movie/2. 카리스마 탈출기.webp')
    },
    {
      id: 3,
      title: 'HAAN 한길수',
      year: '2005',
      image: require('./movie/3. HAAN 한길수.webp')
    },
    {
      id: 4,
      title: '유아독존',
      year: '2002',
      image: require('./movie/4. 유아독존.webp')
    },
    {
      id: 5,
      title: '조폭마누라',
      year: '2001',
      image: require('./movie/5. 조폭마누라.webp')
    },
    {
      id: 6,
      title: '휴머니스트',
      year: '2001',
      image: require('./movie/6. 휴머니스트.webp')
    },
    {
      id: 7,
      title: '닥터K',
      year: '1999',
      image: require('./movie/7. 닥터K.webp')
    },
  ],
  drama: [
    {
      id: 1,
      title: '구미호뎐1938',
      year: '2023',
      image: require('./drama/1. 구미호뎐1938.webp')
    },
    {
      id: 2,
      title: '야인이즈백',
      year: '2021',
      image: require('./drama/2. 야인이즈백.webp')
    },
    {
      id: 3,
      title: '아모르파티',
      year: '2021',
      image: require('./drama/3. 아모르파티.webp')
    },
    {
      id: 4,
      title: '메모리스트',
      year: '2020',
      image: require('./drama/4. 메모리스트.webp')
    },
    {
      id: 5,
      title: '전생에 웬수들',
      year: '2017',
      image: require('./drama/5. 전생에 웬수들.webp')
    },
    {
      id: 6,
      title: '최강배달꾼',
      year: '2017',
      image: require('./drama/6. 최강배달꾼.webp')
    },
    {
      id: 7,
      title: '장사의신-객주2015',
      year: '2016',
      image: require('./drama/7. 장사의신-객주2015.webp')
    },
    {
      id: 8,
      title: '위대한 조강지처',
      year: '2015',
      image: require('./drama/8. 위대한 조강지처.webp')
    },
    {
      id: 9,
      title: '원혼',
      year: '2014',
      image: require('./drama/9. 원혼.webp')
    },
    {
      id: 10,
      title: '정도전',
      year: '2014',
      image: require('./drama/10. 정도전.webp')
    },
    {
      id: 11,
      title: '환상거탑',
      year: '2013',
      image: require('./drama/11. 환상거탑.webp')
    },
    {
      id: 12,
      title: '야인시대',
      year: '2002',
      image: require('./drama/12. 야인시대.webp')
    },
  ]
};